import requestProvider from "./axiosHandler";

const getAllCategory = () => {

    return requestProvider
        .get("/category/get-all")
}
const createCategory = (list) => {

    return requestProvider
        .post("/category",{
            name: list.name,
            code: list.code,
            description: list.description,
            brand: {
                id: list.brandId
            }
        })
}

const deleteCategory = (id) => {

    return requestProvider
        .delete(`/category/${id}`)
}

const getCategoryById = (id) => {

    return requestProvider
        .get(`/category/${id}`)
}

const updateCategory = (list) => {

    return requestProvider
        .put("/category", {
            name: list.name,
            code: list.code,
            description: list.description,
            id: list.id,
            brand: {
                id: list.brandId
            }
        })
};

const getCategoriesWithPage = (page = 0, pageSize = 10) => {
    return requestProvider
        .get(`/category?field=createdDate&order=desc&page=${page}&per_page=${pageSize}`)
}; 

export {getAllCategory, createCategory, deleteCategory, getCategoryById, updateCategory, getCategoriesWithPage}